<template>
    <DesktopStickyBanner
        v-if="showDesktopSticky"
        :key="$route.path"
    />
    <MobileStickyBanner
        v-if="showMobileSticky"
        :key="$route.path"
    />
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { computed } from 'vue'
import { useRoute } from 'vue-router'

import { usePWAInstallStore } from '@/components_new/PWAInstall/store'
import { isPWARuntime } from '@/components_new/PWAInstall/utils'
import { useAppStore } from '@/store/app-store'
import { useGoogleAuth } from '@/store/google-auth-store'
import { useLayoutStore } from '@/store/layout-store'

import DesktopStickyBanner from './DesktopStickyBanner.vue'
import MobileStickyBanner from './MobileStickyBanner.vue'

const pwaInstallStore = usePWAInstallStore()
const { promptDisplayed } = storeToRefs(useGoogleAuth())
const $route = useRoute()
const { fullScreen } = storeToRefs(useLayoutStore())
const { platform } = useAppStore()

const showDesktopSticky = computed(() => platform === 'desktop' && $route.meta.showDesktopStickyBanner)

const showMobileSticky = computed(
    () =>
        platform !== 'desktop' &&
        $route.meta.showMobileStickyBanner &&
        !fullScreen.value &&
        !pwaInstallStore.isDisplaying &&
        !isPWARuntime() &&
        !promptDisplayed.value,
)
</script>
